import { parsePhoneNumber } from 'awesome-phonenumber'

export function phoneLabel(phone: string){
    return parsePhoneNumber(phone)?.number?.international || phone
}